export const LIST_RECEIVABLE = 'LIST_RECEIVABLE'
export const LIST_DAILY_RECEIVABLE = 'LIST_DAILY_RECEIVABLE'
export const LIST_INSTALLMENT = 'LIST_INSTALLMENT'
export const DETAIL_RECEIVABLE = 'DETAIL_RECEIVABLE'
export const SUMMARY_RECEIVABLE = 'SUMMARY_RECEIVABLE'
export const CHECK_RECEIVABLE = 'CHECK_RECEIVABLE'
